import React from 'react';

import DatePicker from 'react-datepicker';
import { FieldComponent, InputField } from '@jutro/components';
import { SgDateUtil } from 'saga-modules';
import _ from 'lodash';
import moment from 'moment';
import CommonConstants from 'sg-common-constants';

class SgDatePicker extends FieldComponent {
    static propTypes = {
        ...FieldComponent.propTypes
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            fieldChanged: false
        };
    }

    componentDidMount() {
        const {
            customId,
            modelVM,
            path,
            onValidate
        } = this.props;

        const date = _.get(modelVM, path);
        if (SgDateUtil.dateIsValid(date.value) && !moment([date.value.year, date.value.month, date.value.day]).isValid()) {
            date.value = undefined;
        }

        if (onValidate) {
            onValidate(_.get(modelVM, path).aspects.valid, customId);
        }
    }

    componentDidUpdate(prevData) {
        const {
            customId,
            modelVM,
            path,
            onValidate,
            value,
            isDateValid
        } = this.props;
        const valueChanged = !_.isEqual(value, prevData.value);
        const isValid = _.get(modelVM, path).aspects.valid;

        if (onValidate && (valueChanged || (!_.isNil(isDateValid) && !_.isNil(isValid) && isDateValid !== isValid))) {
            onValidate(isValid, customId);
        }
    }

    componentWillUnmount() {
        const {
            customId,
            onValidate,
        } = this.props;
        onValidate(true, customId);
    }

    showErrors() {
        return !_.get(this.props.modelVM, `${this.props.path}.aspects.valid`)
            && (this.state.fieldChanged || this.props.showErrors);
    }

    getValidationMessages() {
        return [_.get(this.props.modelVM, `${this.props.path}.aspects.validationMessage`)];
    }

    onChange = (newValue) => {
        this.setState({ fieldChanged: true });
        this.props.writeValue(SgDateUtil.toLocalDateDto(newValue));
    }

    handleFocusOnOpen = () => {
        const datePicker = document.getElementsByClassName('react-datepicker-popper')[0];
        const firstSelectableDate = datePicker.querySelectorAll('div[aria-selected="true"]')[0]
            || datePicker.querySelectorAll('div[role="option"][aria-disabled="false"]')[0];
        if (firstSelectableDate) {
            firstSelectableDate.focus();
        }
    }

    renderControl() {
        const dynamicProps = {};
        if (this.props.maxDate) {
            dynamicProps.maxDate = moment(this.props.maxDate).endOf('day').toDate();
        }
        if (this.props.minDate) {
            dynamicProps.minDate = moment(this.props.minDate).startOf('day').toDate();
        }

        const DateInput = React.forwardRef(
            ({
                className, onChange, placeholder, value, id, onClick
            }, ref) => {
                const onKeyUp = (e) => {
                    e.preventDefault();
                    if (e.key !== CommonConstants.EVENT_KEYS.TAB_KEY) {
                        onClick();
                    }
                };
                return (
                    <div
                        onClick={onClick}
                        onKeyUp={onKeyUp}
                        role="button"
                        tabIndex="-1"
                    >
                        <InputField
                            forwardedRef={ref}
                            className="sgDatePickerMargin"
                            controlClassName={className}
                            onValueChange={onChange}
                            placeholder={placeholder}
                            value={value}
                            id={`${id}Input`}
                        />
                    </div>
                );
            }
        );

        return (
            <DatePicker
                id={this.props.customId}
                selected={this.props.value}
                onChange={this.onChange}
                monthsShown={2}
                placeholderText="dd/mm/yyyy"
                dateFormat="dd/MM/yyyy"
                className={this.props.disabled ? 'sgDatePickerFieldDisabled' : 'sgDatePickerField'}
                onCalendarOpen={this.handleFocusOnOpen}
                customInput={<DateInput />}
                disabled={this.props.disabled}
                onKeyDown={(e) => {
                    if (this.props.disabledManualInput) {
                        e.preventDefault();
                    }
                }}
                {...dynamicProps}
            >
                {this.props.additionalDatePickerText && (
                    <div className="sgDatepickerAdditionalText">{this.props.additionalDatePickerText}</div>
                )}
            </DatePicker>

        );
    }

    render() {
        return super.render();
    }
}

export default SgDatePicker;
